module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAYAAABNChwpAAABSklEQVRIieXWzSoHYRTH8Y/3QhJLZcPCRkkpRTYKF+ACLCwtKBfgBizsZIPchQ15CyXExsoCS6UkpNDUEDX/MRr/eRZ+NU/TOec559vT83Iq2jZv5FAt5jGBemxgBmdZU1bmqY4FTKExzjWMLbQXAdCCyQR7M2aLAOhCdQnfUBEALSm+jiIAOlN8jUUAjOWYmxugGyMp/vtyAkRnfwkVKTF35QKIiq+h/4e486wJSx2jJPViEX0ZYmswnWB/ir9LbOM1uoqbMIC6L4G32EFDnGgUg7+AzaL9aB9FAMfoSZgwh9WYtlxarCxR3G9usxwaT9uEVQUAtOZ9DfPqIjTAQWiAw38N8IzTkAAneAkJcBANIQH2QgPshgS4wnVIgL2Pn1AAu1kBasoE8G0F3koEPcYNyV9rHUdfAVYSKkRt0/IfV36Im9nxTwveAd/pNMXv7h1IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hand-active.png
// module id = QfKt
// module chunks = 0